/* istanbul ignore file */
import { mdiPlay } from '@lumapps/lumx/icons';

export const WIDGET_PLAY_TYPE = 'play';
export const WIDGET_PLAY_ICON = mdiPlay;
export const WIDGET_PLAY_EDITION_SCOPE = 'editable-widget-play';
